/** @deprecated */
export const enum SLAEventLabel {
    ChatConnection = 'chatConnection',
}
